import { render } from "./AutomatedScenarioEditor.vue?vue&type=template&id=3ebb8f44"
import script from "./AutomatedScenarioEditor.vue?vue&type=script&lang=ts"
export * from "./AutomatedScenarioEditor.vue?vue&type=script&lang=ts"

import "./AutomatedScenarioEditor.vue?vue&type=style&index=0&id=3ebb8f44&lang=scss"
script.render = render

export default script